import {Pipe, PipeTransform} from '@angular/core';
import {Constants} from '../constants';
import {sprintf} from 'sprintf-js';
import {TranslationsService} from '../services/translations.service';
import {ConfigService} from '../services/config.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  /**
   * Resource bundle key prefix
   * @var {string}
   */
  private _resourceBundlePrefix: string;

  /**
   * Application configuration
   * @var {any}
   */
  private _config: any;

  /**
   * Translations object
   * @var {object}
   */
  private readonly _translations: object = {};

  /**
   * Class constructor
   *
   * @param _configService
   * @param _translationsService
   */
  constructor(
      private _configService: ConfigService,
      private _translationsService: TranslationsService
  ) {
    this._config = this._configService.getConfig();
    this._translations = this._translationsService.getTranslations();

    this._resourceBundlePrefix = `RESOURCE_BUNDLE_PREFIX_${this._config.brand.toUpperCase()}`;
  }

  /**
   * Translate key and fill placeholders
   * @param {string} key The translation key
   * @param {Array<string | number>} content Content to replace placeholders with if applicable
   *
   * @returns {string} The translated key with placeholders filled
   */
  public transform(key: string, content?: Array<string | number>): string {
    key = this._buildTranslationKey(key);

    let translatedString = key;

    if (this._isTranslationsObjectSet() && this._translations.hasOwnProperty(key)) {
      translatedString = this._translations[key];

      if (!!content && !!content.length) {
        translatedString = sprintf(translatedString, content);
      }
    }

    return translatedString;
  }

  /**
   * Checks if translations object is set and contains data
   *
   * @private
   * @returns {boolean}
   */
  private _isTranslationsObjectSet(): boolean {
    return !!this._translations && typeof(this._translations) === 'object';
  }

  /**
   * Appends resource bundle prefix to a translation key
   *
   * @param key
   * @private
   * @returns {string}
   */
  private _buildTranslationKey(key: string): string {
    return `${Constants[this._resourceBundlePrefix]}${key.trim()}`;
  }

}